const INSTAGRAM_MAX_HASHTAGS = 5;

const HASHTAG_ERROR_MESSAGE = (count: number) =>
    `Instagram allows max ${INSTAGRAM_MAX_HASHTAGS} hashtags. You're using ${count} please reduce to continue.`;

function countHashtags(content: string): number {
    // Count every '#' character in the content.
    // Instagram treats any '#' as a hashtag token — regardless of what follows it.
    return (content?.match(/#/g) ?? []).length;
}

interface InstagramHashtagValidation {
    isViolated: boolean;
    hashtagCount: number;
    maxHashtags: number;
    errorMessage: string;
}

export function useInstagramHashtagValidation(
    content: string,
    platform: string | undefined
): InstagramHashtagValidation {
    const isInstagram = platform?.toLowerCase() === "instagram";
    const hashtagCount = isInstagram ? countHashtags(content) : 0;
    const isViolated = isInstagram && hashtagCount > INSTAGRAM_MAX_HASHTAGS;

    return {
        isViolated,
        hashtagCount,
        maxHashtags: INSTAGRAM_MAX_HASHTAGS,
        errorMessage: HASHTAG_ERROR_MESSAGE(hashtagCount),
    };
}

/**
 * Non-hook version for use outside React components (e.g. in event handlers
 * that receive content/platform at call time rather than render time).
 */
export function checkInstagramHashtagViolation(
    content: string,
    platform: string | undefined
): { isViolated: boolean; hashtagCount: number; errorMessage: string } {
    const isInstagram = platform?.toLowerCase() === "instagram";
    const hashtagCount = isInstagram ? countHashtags(content) : 0;
    const isViolated = isInstagram && hashtagCount > INSTAGRAM_MAX_HASHTAGS;
    return { isViolated, hashtagCount, errorMessage: HASHTAG_ERROR_MESSAGE(hashtagCount) };
}
